// Minimal class-name joiner. Filters out falsy values so conditional classes
// read cleanly: cn('base', isActive && 'active', className). We don't dedupe
// Tailwind conflicts — consumers pass additive/override classes intentionally,
// and later classes in the string win per CSS source order for equal specificity.
export type ClassValue = string | number | false | null | undefined;

export function cn(...parts: ClassValue[]): string {
  return parts.filter(Boolean).join(' ');
}
